export const BOOKING_TERMS_ACCEPTANCE_SOURCE = {
  PUBLIC_ITINERARY: 'PUBLIC_ITINERARY',
  SHARED_BOOKING_LINK: 'SHARED_BOOKING_LINK'
};

export const buildBookingTermsAcceptance = ({
  accepted,
  enabled,
  requiresSignedDocument,
  termsLink,
  pathname = ''
}) => {
  if (
    accepted !== true ||
    enabled !== true ||
    requiresSignedDocument === true
  ) {
    return undefined;
  }

  return {
    accepted: true,
    termsLink: termsLink || '',
    source: pathname.startsWith('/shared/trip/')
      ? BOOKING_TERMS_ACCEPTANCE_SOURCE.SHARED_BOOKING_LINK
      : BOOKING_TERMS_ACCEPTANCE_SOURCE.PUBLIC_ITINERARY
  };
};
